/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Space,
  Descriptions,
  Table,
  Collapse,
  Button,
  Flex,
  Typography,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ProductionOrderService from "../../../service/ERP/ProductionOrder.service";
import { orderColumns } from "./model";
import dayjs from "dayjs";
import useGoBack from "../../../hooks/useGoBack";
import ActionGroup, { PrintButton } from "../../../components/action-group/ActionGroup";

const pdService = ProductionOrderService();

export default function ProductionOrderView() {
  const location = useLocation();

  const { config } = location.state || { config: null };

  const [header, setHeader] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  /* กลับไปหน้าที่กดรหัสเอกสารมา ถ้าไม่มีประวัติค่อยกลับหน้ารายการ */
  const handleClose = useGoBack("/ERP/product-order");

  useEffect(() => {
    if (!config?.record?.pdcode) {
      handleClose();
      return;
    }
    let ignore = false;
    setLoading(true);
    pdService
      .get(config.record.pdcode, { ignoreLoading: true })
      .then((res) => {
        if (ignore) return;
        const data = res?.data?.data;
        setHeader(data?.header || null);
        setOrders(Array.isArray(data?.orders) ? data.orders : []);
      })
      .catch(() => {
        if (!ignore) handleClose();
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [config?.record?.pdcode]);

  const masterItems = [
    { label: "PD Code", children: header?.pdcode || "-" },
    {
      label: "PD Date",
      children: header?.pddate ? dayjs(header.pddate).format("DD/MM/YYYY") : "-",
    },
    { label: "Doc Status", children: header?.doc_status || "-" },
  ];

  const orderCollapseItems = [
    {
      key: "1",
      label: "รายการ Production Order",
      children: (
        <Table
          style={{ backgroundColor: "#fafafa" }}
          bordered
          dataSource={orders}
          columns={orderColumns}
          pagination={false}
          rowKey="code"
          scroll={{ x: "max-content" }}
          size="small"
          loading={loading}
        />
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  /* ใบขอเบิกเพื่อเตรียมการผลิตประจำวัน (ห้องสารส่วนผสม) */
  const handleMixingRoom = () => {
    const pdcode = header?.pdcode || config?.record?.pdcode;
    if (!pdcode) return;
    window.open(`/pd-requisition-print/${encodeURIComponent(pdcode)}`, "_blank");
  };

  /* ใบขอเบิกเพื่อเตรียมการผลิตประจำวัน (ห้องตัดแต่ง) */
  const handleTrimRoom = () => {
    const pdcode = header?.pdcode || config?.record?.pdcode;
    if (!pdcode) return;
    window.open(`/pd-trim-room/${encodeURIComponent(pdcode)}`, "_blank");
  };

  /* ใบสั่งงานการผลิต (A4 แนวนอน + ดาวน์โหลด Excel) */
  const handleWorkOrder = () => {
    const pdcode = header?.pdcode || config?.record?.pdcode;
    if (!pdcode) return;
    window.open(`/pd-work-order/${encodeURIComponent(pdcode)}`, "_blank");
  };

  const ButtonLeft = (
    <Space gap="small" align="center" style={{ display: "flex", justifyContent: "start" }}>
      <Button style={{ width: 120 }} icon={<ArrowLeftOutlined />} onClick={handleClose}>
        กลับ
      </Button>
      <ActionGroup type="print">
        <PrintButton disabled={!header?.pdcode} onClick={handleMixingRoom}>ห้องสารส่วนผสม</PrintButton>
        <PrintButton disabled={!header?.pdcode} onClick={handleTrimRoom}>ห้องตัดแต่ง</PrintButton>
        <PrintButton disabled={!header?.pdcode} onClick={handleWorkOrder}>ใบสั่งงานการผลิต</PrintButton>
      </ActionGroup>
    </Space>
  );

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ display: "flex", position: "relative", paddingInline: "1.34rem" }}
      className="productionorder-view"
    >
      <Row gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]} className="m-0">
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
          {ButtonLeft}
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
          <Flex justify="end" align="center">
            <Typography.Title level={4} className="m-0 !text-zinc-700">
              {config?.title || "View Production Order"}
            </Typography.Title>
          </Flex>
        </Col>
      </Row>

      <Descriptions
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
        items={masterItems}
      />

      <Collapse
        size="large"
        className="view-collapse-sp"
        collapsible="disabled"
        activeKey="1"
        bordered={false}
        style={{ backgroundColor: "transparent" }}
        items={orderCollapseItems}
      />

      <Row gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]} className="mx-0 mb-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
          {ButtonLeft}
        </Col>
      </Row>
    </Space>
  );
}